/* eslint-disable */
/**
 * Single source of truth for the UPNMG-FUND letterhead: the logo asset and the
 * organisation details printed on the statement PDF and on branded page
 * headers in the app.
 *
 * The logo lives in /public so it is reachable both as an <img src> and via
 * canvas when the PDF builder needs it as a data URI.
 *
 * This is the hand-and-leaf mark on its own — roughly square, no wordmark — so
 * everything that draws it also typesets the name beside it, the way the
 * printed statement does. It doubles as the page watermark. Callers read the
 * real aspect ratio off `loadLogo()` rather than assuming one, so swapping in
 * a differently-proportioned file still lays out without distortion.
 */
export const LOGO_URL = "/images/fund-logo.png";

// Taken from the official UPNMG-FUND letterhead. The union's full name
// ("Union of Professional Nurses & Midwives, Ghana") is deliberately absent —
// the letterhead doesn't carry it, only the wordmark and tagline.
export const ORG = {
  name: ["UPNMG", "FUND"], // set on two lines, as on the letterhead
  tagline: "Wealth, Welfare and Beyond",
  postalAddress: "P.O.Box ms 35, Mile 7 – Accra",
  tel: "+233 24 221 5305/+233 24 221 5307",
  email: "upnmgfund@gmail.com",
  ourRef: "UPNMG/FD/001",
};

// Colours lifted from the printed letterhead.
export const BRAND_COLORS = {
  green: "#1B5E3A",
  gold: "#E09B2D",
  rule: "#1F3864",
};

let logoPromise;

/**
 * Loads the logo once and caches it as { dataUrl, width, height }.
 * Resolves to null when the asset is missing so callers can degrade to a
 * text-only letterhead instead of throwing.
 */
export function loadLogo() {
  if (!logoPromise) {
    logoPromise = new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          canvas.getContext("2d").drawImage(img, 0, 0);
          resolve({
            dataUrl: canvas.toDataURL("image/png"),
            width: img.naturalWidth,
            height: img.naturalHeight,
          });
        } catch (e) {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = LOGO_URL;
    });
  }
  return logoPromise;
}
